import { Reducer } from 'redux';
import { MobileLoginProcessStepCodesEnum } from 'app/common/components/Modals/MemberLoginModal/types';
import { LoginState, LoginActions, MEMBER_LOGIN__SET_MOBILE_LOGIN_CURRENT_STEP, MEMBER_LOGIN__FETCH_CAPTCHA_DONE, MEMBER_LOGIN__SAVE_MOBILE_LOGIN_DATA, MEMBER_LOGIN__SEND_OTP_DONE, MEMBER_LOGIN__RESEND_OTP_DONE, MEMBER_LOGIN__SET_LOGIN_REDIRECT_URL, MEMBER_LOGIN__RESET_LOGIN_CACHE } from './types';

const initialState: LoginState = {
  static: {},
  mobileLoginProcess: {
    currentStep: MobileLoginProcessStepCodesEnum.Login
  }
};

const loginnReducer: Reducer<LoginState, LoginActions> = (state = initialState, action): LoginState => {
  switch (action.type) {
    // 設置手機驗證登入當前步驟
    case MEMBER_LOGIN__SET_MOBILE_LOGIN_CURRENT_STEP: {
      return { ...state, mobileLoginProcess: { ...state.mobileLoginProcess, currentStep: action.payload.step } };
    }
    // 取得圖形驗證碼 完成
    case MEMBER_LOGIN__FETCH_CAPTCHA_DONE: {
      return { ...state, static: { ...state.static, captcha: action.payload.response } };
    }
    // 緩存手機驗證登入 (Step-1) 表單資料
    case MEMBER_LOGIN__SAVE_MOBILE_LOGIN_DATA: {
      return { ...state, mobileLoginProcess: { ...state.mobileLoginProcess, data: action.payload.data } };
    }
    // 發送 OTP 驗證碼 完成
    // 重新發送 OTP 驗證碼 完成
    case MEMBER_LOGIN__SEND_OTP_DONE:
    case MEMBER_LOGIN__RESEND_OTP_DONE: {
      return { ...state, mobileLoginProcess: { ...state.mobileLoginProcess, otp: action.payload.response } };
    }
    // 設置 Redirect URL (登入完成後依路線轉導)
    case MEMBER_LOGIN__SET_LOGIN_REDIRECT_URL: {
      return { ...state, redirectURL: action.payload.route, redirectRouteState: action.payload.state };
    }
    // 重置登入流程資料緩存
    case MEMBER_LOGIN__RESET_LOGIN_CACHE: {
      return { ...initialState };
    }
    // Default
    default:
      return state;
  }
};

export default loginnReducer;
